var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "tx-board-header" },
    [
      _c("div", { staticClass: "tx-board-header__identity" }, [
        _c("strong", [
          _c("span", { staticClass: "tx-board-header__table-id" }, [
            _vm._v(
              _vm._s(
                _vm.useName ? _vm.table.name || _vm.table.code : _vm.table.code
              ) +
                " #" +
                _vm._s(_vm.table.round)
            ),
          ]),
        ]),
      ]),
      _c("TaiXiuDiceRow", {
        staticClass: "tx-board-header__dice",
        attrs: {
          table: _vm.table,
          "is-rolling": _vm.isRolling,
          "float-result": _vm.floatResult,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }